import { render, staticRenderFns } from "./AddMenuSet.vue?vue&type=template&id=2b9408f4&"
import script from "./AddMenuSet.vue?vue&type=script&lang=js&"
export * from "./AddMenuSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports